module.exports = __webpack_public_path__ + "45ef5e7b27905f8d0510d496e3a32be5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-princess-s.png
// module id = 2842
// module chunks = 0